import { codeUnitString } from "./code-unit-string.js";
//#region src/single-line-text.ts
/**
* One line of text, a rule that several contracts share: the CP audit ingest (`cpAuditSingleLine`),
* the read-audit details and the DP log query levels.
*
* This module imports only `code-unit-string.ts`, which imports only zod, so a contract of any
* domain can use the rule and no module cycle can pass through it.
*/
/**
* The schema of one line of text: 1 to `max` UTF-16 code units with no control character (\p{Cc}).
*
* Input: `max`, a positive integer. Output: a zod string schema whose length rule counts UTF-16
* code units ({@link codeUnitString}). A value with a control character
* fails with the message `must not contain a control character`; an empty value or one over `max`
* fails the length rule. Pure.
*/
const singleLineText = (max) => codeUnitString().min(1).max(max).regex(/^\P{Cc}+$/u, "must not contain a control character");
//#endregion
export { singleLineText };

//# sourceMappingURL=single-line-text.js.map